/**
 * Shared TypeScript types and interfaces
 * Used by Angular, React, and Node.js backend
 */

// User related types
export interface User {
  id: number;
  name: string;
  email: string;
  role: 'admin' | 'agent' | 'team-leader';
}

// API Response wrapper
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// Enrollment types (example from your hubadmin)
export interface EnrollmentData {
  agentId: number;
  programId: number;
  name: string;
  email: string;
  phone: string;
  status: 'pending' | 'approved' | 'rejected';
}

// Export API endpoints (framework-agnostic)
export * from './api';

// Export interfaces
export * from './interfaces/engagement.interface';
export type { CreateEngagementContentRequest } from './interfaces/engagement.interface';

// Export model interfaces (framework-agnostic)
export * from './models';

// Export Target Achievements specific types
export * from './models/target-achievements/point-structure';
export * from './models/target-achievements/target';

// Add more types as you extract them from Angular/PHP
